<script setup lang="ts">
import { computed } from 'vue';
import { classNames } from '@/js/lib/bem';

export type BaseIconName =
  | 'arrow-left'
  | 'left'
  | 'logo'
  | 'menu-alt'
  | 'mail-opened'
  | 'successfully'
  | 'book-open'
  | 'book-lock'
  | 'grid-streamline'
  | 'person'
  | 'logout'
  | 'download'
  | 'search'
  | 'add-row'
  | 'notification'
  | 'person-success'
  | 'plum'
  | 'book-settings'
  | 'users-plus'
  | 'add-square'
  | 'x'
  | 'paperclip'
  | 'sliders'
  | 'edit'
  | 'check'
  | 'clock'
  | 'save'
  | 'eye'
  | 'trash';

const props = withDefaults(
  defineProps<{
    type?: 'main'
    name: BaseIconName
    width?: number
    height?: number
    label?: string
  }>(),
  {
    type: 'main',
    width: 24,
    height: 24,
    label: undefined,
  },
);

const cn = classNames('base-icon');

const href = computed(() => `/sprites/${props.type}.svg#${props.name}`);

const iconClasses = computed(() => cn());

const size = computed(() => ({
  width: Math.max(1, props.width),
  height: Math.max(1, props.height),
}));

const isDecorative = computed(
  () => props.label === undefined || props.label === '',
);
</script>

<template>
  <svg
    :class="iconClasses"
    :width="size.width"
    :height="size.height"
    :aria-hidden="isDecorative ? 'true' : undefined"
    :aria-label="isDecorative ? undefined : label"
    :role="isDecorative ? undefined : 'img'"
  >
    <use :href="href" />
  </svg>
</template>

<style lang="scss" scoped>
.base-icon {
  display: block;
  flex-shrink: 0;
}
</style>
